import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useClientQueries } from '@zenstackhq/tanstack-query/react';
import { registerSchema, type RegisterInput } from '@zsp/shared';
import { schema } from '../../__generated__/schema-lite';
import { useAuth } from '../../auth/AuthContext';
import { zodFormResolver } from '../../lib/zodFormResolver';
import { translateError } from '../../lib/translate-error';

/** Register page ViewModel: owns signUp mutation, form, and post-submit navigation. */
export function useRegisterPageVM() {
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const { t } = useTranslation();
  const crud = useClientQueries(schema);
  const signUp = crud.$procs.signUp.useMutation();

  const { register, handleSubmit, formState } = useForm<RegisterInput>({
    resolver: zodFormResolver<RegisterInput>(registerSchema),
  });

  const onSubmit = handleSubmit(async (values) => {
    try {
      const token = await signUp.mutateAsync({ args: { input: values } });
      setToken(token);
      toast.success(t('register.welcome'));
      navigate('/', { replace: true });
    } catch (err) {
      toast.error(translateError(t, err));
    }
  });

  return { register, formState, onSubmit };
}
